module.exports = __webpack_public_path__ + "img/Makoto Inoue.d7e0dcde.jpg";